import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

// El menu sigue el flujo real del negocio, en orden:
// pedido del cliente -> orden de compra al proveedor -> produccion ->
// embarque -> recepcion -> inventario -> surtido al cliente.
// Abajo quedan los procesos que cuelgan del flujo (maquila, devoluciones) y
// los reportes que lo cruzan.
const ITEMS = [
  { type: "section", label: "El flujo" },
  { label: "1. Pedidos del cliente", icon: "fas fa-shopping-basket", color: "#10b981", bg: "#f0fdf4", href: "/ListadoPedidos", desc: "Capturar o subir el OC del cliente y darle seguimiento", perm: "menu_pedidos" },
  { label: "2. PO", icon: "fas fa-file-signature", color: "#6366f1", bg: "#eef2ff", href: "/ListadoOrdenesCompra", desc: "Lo que se le pide al proveedor y su produccion", perm: "menu_oc" },
  { label: "3. Embarques", icon: "fas fa-ship", color: "#0ea5e9", bg: "#f0f9ff", href: "/ListadoEmbarques", desc: "Contenedores consolidados y su recepcion", perm: "embarques" },
  { label: "4. Inventario", icon: "fas fa-boxes", color: "#f59e0b", bg: "#fffbeb", href: "/ListadoInventarios", desc: "Existencia por color y talla", perm: "inventarios" },
  { label: "5. Surtir pedidos", icon: "fas fa-dolly", color: "#16a34a", bg: "#f0fdf4", href: "/SurtirPedidos", desc: "Solo los pedidos con piezas por surtir, cada uno con su boton de surtir", perm: "surtidos_create" },
  { label: "6. Notas de surtido", icon: "fas fa-truck-moving", color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoSurtidos", desc: "Notas ya hechas", perm: "menu_surtidos" },

  { type: "section", label: "El tablero" },
  { label: "Seguimiento General", icon: "fas fa-table", color: "#f43f5e", bg: "#fff1f2", href: "/SeguimientoGeneral", desc: "Todo el flujo en un renglon por modelo: pedido, orden, embarque y entrega", perm: "menu_ventas" },

  { type: "section", label: "Otros accesos" },
  { label: "Tracking Mexico", icon: "fas fa-flag", color: "#3b82f6", bg: "#eff6ff", href: "/SeguimientoMX", desc: "Preparacion de la orden", perm: "menu_oc" },
  { label: "Tracking China", icon: "fas fa-globe-asia", color: "#f43f5e", bg: "#fff1f2", href: "/SeguimientoChina", desc: "Avance del proveedor", perm: "menu_oc" },
  // { label: "Pendiente Embarcar", icon: "fas fa-hourglass-half", color: "#f59e0b", bg: "#fffbeb", href: "/ListadoPendEmbarcar", desc: "Ordenes sin embarcar", perm: "pendiente_embarcar" },  // se ve desde la orden de compra
  // { label: "Pendiente Recibir", icon: "fas fa-hourglass-end", color: "#f59e0b", bg: "#fffbeb", href: "/ListadoPendRecibir", desc: "Embarques en transito", perm: "pendiente_recibir" },  // se recibe desde el embarque
  { label: "Entradas", icon: "fas fa-box-open", color: "#10b981", bg: "#f0fdf4", href: "/ListadoCompras", desc: "Recepciones ya hechas", perm: "menu_compras" },
  // { label: "Notas", icon: "fas fa-file-invoice-dollar", color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoSurtidos", desc: "Notas de remision", perm: "menu_surtidos" },  // es el paso 5
  { label: "Devoluciones", icon: "fas fa-undo-alt", color: "#f43f5e", bg: "#fff1f2", href: "/ListadoDevoluciones", desc: "Lo que regresa el cliente", perm: "menu_devoluciones" },
  { label: "Compra Directa", icon: "fas fa-cart-plus", color: "#14b8a6", bg: "#f0fdfa", href: "/ComprasDirectasCreate", desc: "Comprar sin orden previa", perm: "compras_create" },
  { label: "Venta Directa", icon: "fas fa-cash-register", color: "#10b981", bg: "#f0fdf4", href: "/VentaDirectaCreate", desc: "Vender sin pedido previo", perm: "menu_ventas" },
  // { label: "Maquilas", icon: "fas fa-people-carry", color: "#f59e0b", bg: "#fffbeb", href: "/ListadoProcesosSalida", desc: "Salida y entrada de maquila", perm: "menu_procesos" },  // no es parte del flujo del cliente
  // { label: "Corte Diario", icon: "fas fa-calendar-day", color: "#0ea5e9", bg: "#f0f9ff", href: "/CorteDiario", desc: "Lo que movio el inventario", perm: "inventarios" },  // vive en Inventarios
];

function BotonesOperacion() {
  const { user } = useContext(AuthContext);
  const puede = !!user.menu_ventas || !!user.menu_compras || !!user.inventarios;
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-route" color="#6366f1" bg="#eef2ff" title="Operacion"
          subtitle="El flujo: pedido, orden de compra, embarque, inventario, surtido y notas" />
        {puede ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesOperacion;
